import axios from 'axios';
import type { CodedPrescriptionRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export interface RefillActionApprove {
  action: 'approve';
  refills?: number;
  comment?: string | null;
  effective_date?: string | null;
}

export interface RefillActionDeny {
  action: 'deny';
  denial_reason: string;
  note?: string | null;
}

export interface RefillActionReplace {
  action: 'replace';
  patient_user_id: string;
  new_prescription: CodedPrescriptionRequestT;
}

export type RefillActionRequest = RefillActionApprove | RefillActionDeny | RefillActionReplace;

export interface RxChangeActionApprove {
  action: 'approve';
  selected_medication_id?: number | null;
  prior_auth_number?: string | null;
  comment?: string | null;
}

export interface RxChangeActionDeny {
  action: 'deny';
  denial_reason: string;
  comment?: string | null;
}

export interface RxChangeActionApproveWithChanges {
  action: 'approve_with_changes';
  patient_user_id: string;
  new_prescription: CodedPrescriptionRequestT;
  comment?: string | null;
}

export type RxChangeActionRequest =
  | RxChangeActionApprove
  | RxChangeActionDeny
  | RxChangeActionApproveWithChanges;

export async function submitRefillAction(
  refillId: number,
  request: RefillActionRequest
): Promise<void> {
  const config = await createLotusRequestConfig();
  await axios.post(`/greenfield/dosespot/refills/${refillId}/action`, request, config);
}

export async function submitRxChangeAction(
  rxChangeId: number,
  request: RxChangeActionRequest
): Promise<void> {
  const config = await createLotusRequestConfig();
  await axios.post(`/greenfield/dosespot/rxchanges/${rxChangeId}/action`, request, config);
}
